"use client";

import {
	type ButtonProps,
	CardCarousel,
	type DefaultImageProps,
	type DefaultLinkProps,
	Heading,
	type LinkProps
} from "@pamperedchef/design-system";
import { className } from "@/app/utilities/className";
import type { HeadingTag } from "@/app/utilities/types";

import { CommunityBuzzCard, CommunityBuzzCardProps } from "./CommunityBuzzCard";
import * as styles from "./CommunityBuzzCarousel.module.scss";

export interface CommunityBuzzCarouselProps<
	ImageComponentProps = DefaultImageProps,
	LinkComponentProps = DefaultLinkProps
> {
	headline?: string;
	headingTag?: HeadingTag;
	cta?: Omit<LinkProps<LinkComponentProps>, "kind" | "size">;
	slides: CommunityBuzzCardProps<ImageComponentProps, LinkComponentProps>[];
}

/**
 * CommunityBuzz Carousel
 */
export function CommunityBuzzCarousel<
	ImageComponentProps = DefaultImageProps,
	LinkComponentProps = DefaultLinkProps
>({
	headline,
	headingTag = "h2",
	cta,
	slides
}: CommunityBuzzCarouselProps<
	ImageComponentProps,
	LinkComponentProps
>): JSX.Element {
	return (
		<div {...className(styles["community-carousel"])}>
			<Heading
				styledAs="h1"
				tag={headingTag}
				className={styles["community-carousel__title"]}
			>
				{headline}
			</Heading>
			<CardCarousel<LinkComponentProps>
				allowOverflow
				cta={cta as Omit<LinkProps<ButtonProps>, "kind" | "size">}
				slides={slides.map((slide, index) => (
					<CommunityBuzzCard
						key={`${slide.author}-${index}`}
						{...slide}
					/>
				))}
			/>
		</div>
	);
}
